/* eslint-disable no-unused-expressions */
import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Checkbox from '@mui/material/Checkbox';
import * as actionsBlocks from '../../Redux/Actions/Blocks';
import * as PropertyBucket from '../../Properties/Properties';
import * as httpService from '../HttpService/HttpService';
import {connect} from 'react-redux';
import {QuestionInBlockDto} from '../Dtos/QuestionInBlockDto';


class BlockCheckBoxList extends React.Component {

	classes = this.useStyles;

	constructor(props) {
		super(props);
		this.state = {
			checkedBlocks: this.props.pickedBlocks.pickedBlocks,
			isCheckedMap: new Map(),
			orderMap: new Map(),
			nextOrderNumber: 1,
			checkAll: this.props.blocksToRender.length === this.props.pickedBlocks.pickedBlocks.length,
			checkAllCheckboxDisabled: false,
		};
		this.props.pickedBlocks.pickedBlocks.forEach((block) => {
			this.state.isCheckedMap.set(block.id, true);
			this.state.orderMap.set(block.id, this.state.nextOrderNumber++);
		});
		this.handleAddBlock = this.handleAddBlock.bind(this);
	}

	useStyles = {
		root: {
			width: '100%',
			maxWidth: 360,
			backgroundColor: '#00ACEE',
			className: ''
		}
	};

	getQuestionsForTheBlock = (blockId) => {
		let url = PropertyBucket.getQuestionsByBlock(blockId);
		return this.controlResponse = httpService.getService(url, 'GET');
	};

	convertQuestionIntoQuestionInBlock = (question) => {
		let questionInBlockDto = new QuestionInBlockDto();
		questionInBlockDto.questionContent = question.question === undefined ? question.questionContent : question.question;
		questionInBlockDto.active = question.active;
		questionInBlockDto.orderNumber = question.orderNumber;
		questionInBlockDto.abbrev = question.abbrev;
		questionInBlockDto.additional = question.additional;
		questionInBlockDto.block = question.block;

		return questionInBlockDto;
	};

	handleAddBlock = (block) => {
		block.additionalQuestions = [];
		block.questionsInBlock = [];

		let valueIndex = 0;
		let copiedIsCheckedMap = this.state.isCheckedMap;
		let copiedOrderMap = this.state.orderMap;
		
		if (!this.state.checkedBlocks.some(item => item.id === block.id)) {
			let blocksChecked = this.state.checkedBlocks;
			blocksChecked.push(block);
			
			const usedOrderNumbers = Array.from(copiedOrderMap.values());
			let lowestAvailable = 1;
			while (usedOrderNumbers.includes(lowestAvailable)) {
				lowestAvailable++;
			}
			
			copiedIsCheckedMap.set(block.id, true);
			copiedOrderMap.set(block.id, lowestAvailable);
			
			this.setState({
				checkedBlocks: blocksChecked,
				nextOrderNumber: Math.max(...usedOrderNumbers, lowestAvailable) + 1
			});
		} else {
			valueIndex = this.state.checkedBlocks.findIndex(item => item.id === block.id);
			const removedOrderNumber = copiedOrderMap.get(block.id);
			this.state.checkedBlocks.splice(valueIndex, 1);
			copiedIsCheckedMap.set(block.id, false);
			copiedOrderMap.delete(block.id);
			
			this.state.checkedBlocks.forEach(b => {
				const currentOrder = copiedOrderMap.get(b.id);
				if (currentOrder > removedOrderNumber) {
					copiedOrderMap.set(b.id, currentOrder - 1);
				}
			});
		}
		/**
			/  The picked block array is sent to redux.
		 */
		this.props.pickedData(this.state.checkedBlocks);
		this.setState({
			isCheckedMap: copiedIsCheckedMap,
			orderMap: copiedOrderMap
		});
	};

	addAllBlocks = () => {
		let newIsCheckedMap = new Map();
		let newOrderMap = new Map();
		let blocksChecked = [];
		let orderCounter = 1;
		
		this.props.blocksToRender.forEach((block) => {
			block.additionalQuestions = [];
			block.questionsInBlock = [];

			blocksChecked.push(block);
			newIsCheckedMap.set(block.id, true);
			newOrderMap.set(block.id, orderCounter++);
		});

		blocksChecked.sort(function (a, b) {
			return a.blockId - b.blockId;
		});

		this.setState({
			isCheckedMap: newIsCheckedMap,
			orderMap: newOrderMap,
			nextOrderNumber: orderCounter,
			checkedBlocks: blocksChecked,
			checkAllCheckboxDisabled: false,
		});

		this.props.pickedData(blocksChecked);
	};

	removeAllBlocks = () => {
		// TODO: fix state management in `CreateList.js` - temporary resolution due to wrong state management in parent
		const newArray = this.state.checkedBlocks;
		newArray.splice(0, newArray.length);
		this.setState({
			checkedBlocks: newArray,
			isCheckedMap: new Map(),
			orderMap: new Map(),
			nextOrderNumber: 1
		});
		this.props.pickedData([]);
	};

	checkAllBlocks = (checkState) => {
		this.setState((prevState) => ({
			checkAll: !prevState.checkAll
		}));
		if (checkState) {
			this.removeAllBlocks();
		} else {
			this.addAllBlocks();
		}
	};

	render() {
		return (
			<div>
				<div className='two-column'>
					<div className='ml-26'>
						<Checkbox id='checkAll' edge='start' color='primary' checked={this.state.checkAll}
							onChange={() => this.checkAllBlocks(this.state.checkAll)} disabled={this.state.checkAllCheckboxDisabled}/>
						<label htmlFor='checkAll' className='checkAll'>Zaznacz wszystkie<span className='sr-only'> bloki</span></label>
					</div>
				</div>
				<List>
					{
						this.props.blocksToRender.map((block, index) => {
							const labelId = `checkbox-list-secondary-label-${index}`;
							const inputId = `checkbox-list-secondary-input-${index}`;
							const checked = typeof this.state.isCheckedMap.get(block.id) === 'undefined'
								? false
								: this.state.isCheckedMap.get(block.id);
							const orderNumber = checked ? this.state.orderMap.get(block.id) : null;
							const blockName = block.blockId 
								? block.blockId + '. ' + block.name 
								: block.name;
							const displayText = checked 
								? `${blockName} (${orderNumber})` 
								: blockName;
								
							return (
								<div key={block.id} className='two-column'>
									<ListItem>
										<Checkbox id={inputId}
										          edge='end'
										          color='primary'
										          checked={checked}
										          onChange={() => {
																this.handleAddBlock(block);
																if (this.state.checkAll) {
																	this.setState({ checkAll: false })
																}
															}}
										          label={block.blockId}
										          inputProps={{'aria-labelledby': labelId}}
										/>
										<label style={{ wordBreak: 'break-word' }} htmlFor={inputId} id={labelId}>{displayText}</label>
									</ListItem>
								</div>
							);
						})
					}
				</List>
			</div>
		);
	}
}


const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {
		pickedData: data => dispatch(actionsBlocks.getPickedBlocks(data)),
		blocksData: () => dispatch(actionsBlocks.getTemplateBlocks())
	}
};

export const CheckBoxListProvider = connect(mapStateToProps, mapDispatchToProps)(BlockCheckBoxList);


